export function Personal(props) {
    return (
        <div className='delivery-content'>
            <div className='content wrapper flex-1'>
                <h3>Ваши заказы</h3>
                <p>Оформите заказ, после чего он отобразиться в истории заказов.</p>
            </div>
        </div>
    )
}